import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { fmt } from '@/lib/format';

/**
 * Pie de una lista por cursor: «Mostrando 200 de 437 unidades» y «Cargar más» mientras quede algo por traer
 * (ux-comercial-15 / 16, api-comercial-embudo-07): la lista nunca corta sin avisar.
 */
export function ListFooter({
  shown,
  total,
  noun,
  hasMore,
  loading,
  onMore,
  testId,
}: {
  shown: number;
  total: number | undefined;
  /** Sustantivo en plural: «unidades», «proformas», «procesos». */
  noun: string;
  hasMore: boolean;
  loading: boolean;
  onMore: () => void;
  testId?: string;
}) {
  if (shown === 0) return null;
  return (
    <div
      className="text-muted-foreground flex flex-wrap items-center justify-between gap-2 px-1 text-xs"
      data-testid={testId}
    >
      <span>
        Mostrando {fmt.number(shown)}
        {total !== undefined && total > shown ? ` de ${fmt.number(total)}` : ''} {noun}
      </span>
      {hasMore && (
        <Button type="button" variant="outline" size="sm" onClick={onMore} disabled={loading}>
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Cargar más
        </Button>
      )}
    </div>
  );
}
